var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "write-off-table" },
    [
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-plus" },
                          on: { click: _vm.selectModal },
                        },
                        [_vm._v("选择")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "text-red",
                          attrs: { type: "text", icon: "el-icon-delete" },
                          on: { click: _vm.deleteTable },
                        },
                        [_vm._v("清空")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3876217543
            ),
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "list" },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              attrs: {
                border: "",
                data: _vm.value,
                "checkbox-config": {
                  checkRowKeys: _vm.selection,
                },
                rowId: "auditDetailAttachCode",
                "show-overflow": "",
              },
              on: {
                "checkbox-change": _vm.checkboxChange,
                "checkbox-all": _vm.checkboxAll,
              },
            },
            [
              !_vm.disabled
                ? _c("vxe-table-column", {
                    attrs: {
                      type: "checkbox",
                      fixed: "left",
                      "min-width": "36",
                    },
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: {
                  title: "上账编码",
                  field: "accountCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销编码",
                  field: "auditCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销明细编码",
                  field: "auditDetailCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动明细编码",
                  field: "actDetailCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "附加信息行编号",
                  field: "attachCode",
                  "min-width": "110",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "所属销售公司",
                  field: "ownedSalesCompanyName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "归属客户名称",
                  field: "customerName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动申请编码",
                  field: "actCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动申请名称",
                  field: "actName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动类型",
                  field: "fineName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "投入类型", field: "", "min-width": "100" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动开始时间",
                  field: "beginDate",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "活动结束时间",
                  field: "endDate",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "申请金额",
                  field: "applyAmount",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销金额",
                  field: "auditAmount",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "可上账金额",
                  field: "currentAllowAmount",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "本次上账金额",
                  field: "accountAmount",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !_vm.disabled
                          ? _c("el-input-number", {
                              attrs: {
                                controls: false,
                                min: 0,
                                max: row.currentAllowAmount,
                                precision: 2,
                              },
                              model: {
                                value: row.accountAmount,
                                callback: function ($$v) {
                                  _vm.$set(row, "accountAmount", $$v)
                                },
                                expression: "row.accountAmount",
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(row.accountAmount))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "产品层级",
                  field: "productLevelCode",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        !_vm.disabled
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  remote: "",
                                  placeholder: "产品层级",
                                  "remote-method": function (v) {
                                    return _vm.remoteMethod("lev", rowIndex, v)
                                  },
                                  loading: _vm.loading,
                                  clearable: "",
                                  disabled: row.payType !== "4",
                                },
                                on: {
                                  focus: function () {
                                    return _vm.remoteMethod("lev", rowIndex)
                                  },
                                  change: function (v) {
                                    return _vm.levelChange(v, rowIndex)
                                  },
                                },
                                model: {
                                  value: row.productLevelCode,
                                  callback: function ($$v) {
                                    _vm.$set(row, "productLevelCode", $$v)
                                  },
                                  expression: "row.productLevelCode",
                                },
                              },
                              _vm._l(row.levelOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.productLevelName,
                                    value: item.productLevelCode,
                                  },
                                })
                              }),
                              1
                            )
                          : _c("span", [_vm._v(_vm._s(row.productLevelName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "货补产品",
                  field: "accountProductRespVos",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        !_vm.disabled
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  "reserve-keyword": "",
                                  placeholder: "货补产品",
                                  loading: _vm.loading,
                                  clearable: "",
                                  disabled:
                                    row.payType !== "4" ||
                                    !row.productLevelCode,
                                  multiple: "",
                                  "collapse-tags": "",
                                },
                                on: {
                                  focus: function () {
                                    return _vm.remoteMethod("pro", rowIndex)
                                  },
                                },
                                model: {
                                  value: row.productCode,
                                  callback: function ($$v) {
                                    _vm.$set(row, "productCode", $$v)
                                  },
                                  expression: "row.productCode",
                                },
                              },
                              _vm._l(row.productOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.productName,
                                    value: item.productCode,
                                  },
                                })
                              }),
                              1
                            )
                          : _c("span", [_vm._v(_vm._s(row.productNames))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "财务凭证编号", field: "", "min-width": "100" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销科目名称",
                  field: "auditSubjectName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销科目编码",
                  field: "auditSubjectCode",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销备注",
                  field: "remarks",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "申请人",
                  field: "createName",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "核销年月",
                  field: "createDateAll",
                  "min-width": "100",
                },
              }),
              !_vm.disabled
                ? _c("vxe-table-column", {
                    attrs: {
                      title: "操作",
                      width: "60",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                { staticClass: "setting-btn" },
                                [
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: {
                                        title: "此操作将永久删除该数据？",
                                        "confirm-button-type": "text",
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.removeRow(row)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "reference",
                                            type: "text",
                                          },
                                          slot: "reference",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                            staticStyle: { color: "#f5222d" },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      247235278
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        attrs: { beforeClose: _vm.beforeClose },
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }